// extracted by mini-css-extract-plugin
export default {"root":"register_root__JjHL+","wrapper":"register_wrapper__i864z","head":"register_head__ZNF+R","logo":"register_logo__nUlBB","foot":"register_foot__cmbwl"};